export const firebaseConfig = {
  apiKey: "AIzaSyBOwA9li42jmoH_8cIvopx8p1Yv1V_ltzI",
  authDomain: "admin-demo-91eca.firebaseapp.com",
  projectId: "admin-demo-91eca",
  storageBucket: "admin-demo-91eca.firebasestorage.app",
  messagingSenderId: "990809294144",
  appId: "1:990809294144:web:bdd220d579ceeb1e22a6a5",
  measurementId: "G-Q161M2FMHM"
};
